import { styled } from '@mui/material/styles';
import { Box } from '../../../base';

export const StyledColorSwatch = styled(Box)(({ theme }) => ({
    width: 36,
    height: 36,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    cursor: 'pointer',
    flexShrink: 0,
    transition: 'box-shadow 0.2s',
    '&:hover': {
        boxShadow: theme.shadows[2],
    },
}));

export const StyledColorPickerRow = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 8,
}));

export const StyledColorHexText = styled(Box)(({ theme }) => ({
    fontFamily: 'monospace',
    fontSize: 13,
    color: theme.palette.text.secondary,
}));
